/**
 * Calculates the star rating for a completed puzzle.
 *
 * ★     = solved
 * ★★    = solved without any resets
 * ★★★   = solved in minimum strikes, without undo, without resets
 */
export function calculateStars(
  solved: boolean,
  strikesUsed: number,
  minimumStrikes: number,
  undoUsed: boolean,
  resetsUsed: number,
): number {
  if (!solved) return 0;
  if (strikesUsed <= minimumStrikes && !undoUsed && resetsUsed === 0) return 3;
  if (resetsUsed === 0) return 2;
  return 1;
}
